import InfiniteList from "lib/ui/infinite-list/infinite-list";
import React, { useState } from "react";

import MeterAccessConfigPanel from "./meter-access-config-panel";
import MeterForm from "./meter-form";
import MeterListItem from "./meter-list-item";
import MeterReadings from "./meter-readings";
import MetersData from "./meters-data";

const MeterManagementPageBody = () => {
  const [selectedMeter, setSelectedMeter] = useState(null);

  const onMeterSelection = item => {
    if (item !== selectedMeter) {
      setSelectedMeter(item);
    }
  };

  const renderMeterListItem = item => {
    return <MeterListItem meter={item} />;
  };

  return (
    <>
      <InfiniteList
        getData={MetersData}
        renderListItem={renderMeterListItem}
        onSelect={onMeterSelection}
      />
      {selectedMeter && (
        <div className="w-1/4 ml-10 max-h-full">
          <MeterForm meter={selectedMeter} />
          <MeterAccessConfigPanel meter={selectedMeter} />
        </div>
      )}
      {selectedMeter && (
        <div className="flex flex-col ml-4 w-1/2 items-center">
          <div className="w-full bg-orange-200 rounded p-2">
            Meter Summary
            <div>
              Current Status: Online
              <br />
              Last Reading: 06/18/2020 14:00
            </div>
            <div>Error Readings:</div>
          </div>
          <MeterReadings meter={selectedMeter} />
        </div>
      )}
    </>
  );
};

export default MeterManagementPageBody;
